<template>
  <button
    type="button"
    class="pl-1 pr-1 text-secondary hover:text-secondary-800 focus:text-secondary-800"
    :aria-label="ariaLabel"
    @click="$emit('clear')"
  >
    <i class="el-icon-circle-close"></i>
  </button>
</template>

<script>
export default {
  name: 'base-clear-input-button',
  props: {
    ariaLabel: {
      type: String,
      required: true
    }
  }
}
</script>
